// ContactUsSection.tsx

import ContactUsCard from "@components/BasicComponents/Cards/ContactUsCard/ContactUsCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	ContactUsCardModuleType,
	ContactUsCardType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import styles from "./ContactUsSection.module.scss"

const ContactUsSection = (props: {
	data?: AdvancedSideAssetModuleType
	cards: ContactUsCardModuleType
	backgroundColor?: "white"
}) => {
	const cards = props.cards.cards
	return (
		<section>
			<ContainerWrapper>
				<Typography
					className={styles.cardsCeoSectionTitle}
					content={
						props.data?.sectionTitle ? props.data?.sectionTitle : ""
					}
					noPadding={!props.data?.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Typography
					className={styles.cardsCeoTitle}
					content={props.data?.sectionSubtitle}
					variant={Variant.SectionSubtitle}
				/>

				<Separator
					className={styles.contactContainer}
					size={props.backgroundColor ? 8 : 32}
				>
					{cards.map((element: ContactUsCardType, index: number) => {
						return (
							<ContactUsCard
								key={index}
								backgroundColor={props.backgroundColor}
								className={styles.contactCardContainer}
								data={element}
							/>
						)
					})}
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default ContactUsSection
